import { MatSnackBar, MatSnackBarRef, SimpleSnackBar} from '@angular/material/snack-bar';
import { Injectable } from '@angular/core';
import { MsgLoadingComponent } from '../components/msgLoading/msgLoading.component';

@Injectable({
    providedIn: 'root'
})
export class SnackBarService {

    local:any={};

    constructor(
        private matSnackBar: MatSnackBar
    ){}

    open(msg: string, actionLabel: string = null, cfg: any = { duration: 3000, horizontalPosition: 'left', panelClass:'snackbar'}): MatSnackBarRef<SimpleSnackBar> {
        return this.matSnackBar.open(msg, actionLabel, cfg);
    }

    openComponent(local, data){
        this.local[local] = {
            data : data,
            snack : this.matSnackBar.openFromComponent(MsgLoadingComponent,{data:{local:local, data:data}, panelClass:'snackbar'})
        };
    }

    close(local, timeout = 0){
        if(this.hasSeted(local)){
            setTimeout(() =>{
                if(typeof this.local[local] !== 'undefined')
                    this.local[local]?.snack?.dismiss();
                    
                delete this.local[local];
            },timeout)
            
        }            
    }

    hasSeted(local){
        return typeof this.local[local] !=='undefined';
    }

}
